module.exports = __webpack_public_path__ + "img/admin-mel.c83893e1.png";